import { render, staticRenderFns } from "./ShipOrderProfile.vue?vue&type=template&id=5f76c795&scoped=true&"
import script from "./ShipOrderProfile.vue?vue&type=script&lang=js&"
export * from "./ShipOrderProfile.vue?vue&type=script&lang=js&"
import style0 from "./ShipOrderProfile.vue?vue&type=style&index=0&id=5f76c795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f76c795",
  null
  
)

export default component.exports